import { Phone } from "lucide-react";

const telHref = (phone) => `tel:${String(phone).replace(/[^\d+]/g, "")}`;

// Tap-to-call pill; safe inside links/cards (uses a button, not a nested anchor)
export const CallBadge = ({ phone, size = "sm", className = "", testId = "call-badge" }) => {
  if (!phone) {
    return <span className={`inline-flex items-center gap-1.5 font-body text-slate-500 ${size === "lg" ? "text-base" : "text-sm"} ${className}`} data-testid={`${testId}-coming-soon`}>{size !== "lg" && <Phone className="w-4 h-4" />} Coming soon</span>;
  }
  const pad = size === "lg" ? "px-4 py-2 text-sm" : "px-3 py-1.5 text-xs";
  return (
    <button type="button" data-testid={testId} aria-label={`Call ${phone}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.location.href = telHref(phone); }}
      className={`inline-flex items-center gap-1.5 rounded-full bg-teal text-white font-semibold font-body shadow-sm hover:bg-teal-dark active:scale-95 transition-[background-color,transform] ${pad} ${className}`}>
      <Phone className={size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5"} /> Call {phone}
    </button>
  );
};
